import { Badge, Icon } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import classNames from "classnames"

interface Props {
  onClick?: () => void
}

export const CompanyFraudBadge = ({ onClick }: Props) => {
  const { t } = useTranslation("invoices/CompanyPaymentStatusSection", {
    keyPrefix: "customerPaymentStatus",
  })

  return (
    <Badge
      variation="error"
      isOutline
      onClick={onClick}
      className={classNames({ "cursor-pointer": !!onClick })}
    >
      <Icon name="WarningCircle" />
      {t("states.fraud.label")}
    </Badge>
  )
}
